export default "__VITE_ASSET__B8sgKn4c__"